import * as glMatrix from 'gl-matrix'

type V3 = [number, number, number]

export default {
  updateVelocity: (velocity: V3, acceleration: V3, mass: number) => {
    glMatrix.vec3.scale(acceleration, acceleration, 1 / mass)
    glMatrix.vec3.add(velocity, velocity, acceleration)
  },
  applyFriction: (acceleration: V3, mu: number) => {
    const friction: V3 = [0, 0, 0]
    glMatrix.vec3.scale(friction, acceleration, -1)
    glMatrix.vec3.normalize(friction, friction)
    glMatrix.vec3.scale(friction, friction, mu)
    glMatrix.vec3.add(acceleration, acceleration, friction)
  },
  applyDrag: (acceleration: V3, value: number) => {
    const drag: V3 = [0, 0, 0]
    glMatrix.vec3.scale(drag, acceleration, -1)
    glMatrix.vec3.normalize(drag, drag)
    glMatrix.vec3.scale(drag, drag, glMatrix.vec3.length(acceleration) * value)
    glMatrix.vec3.add(acceleration, acceleration, drag)
  },
  applyHook: (
    velocity: V3,
    acceleration: V3,
    anchor: V3,
    restLength: number,
    k: number
  ) => {
    const hook: V3 = [0, 0, 0]
    glMatrix.vec3.sub(hook, velocity, anchor)
    const distance = glMatrix.vec3.length(hook) - restLength
    glMatrix.vec3.normalize(hook, hook)
    glMatrix.vec3.scale(hook, hook, -1 * k * distance)
    glMatrix.vec3.add(acceleration, acceleration, hook)
  },
}
